/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as DatenschutzRouteImport } from './routes/datenschutz'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as ImpressumRouteImport } from './routes/impressum'
import { Route as LoginRouteImport } from './routes/login'
import { Route as NutzungsbedingungenRouteImport } from './routes/nutzungsbedingungen'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppAccountRouteImport } from './routes/_app/account'
import { Route as AppAdminRouteImport } from './routes/_app/admin'
import { Route as AppClientsRouteImport } from './routes/_app/clients'
import { Route as AppMembersRouteImport } from './routes/_app/members'
import { Route as InviteIdRouteImport } from './routes/invite.$id'
import { Route as AppAdminIndexRouteImport } from './routes/_app/admin/index'
import { Route as AppAdminUsageRouteImport } from './routes/_app/admin/usage'
import { Route as AppAdminUsersRouteImport } from './routes/_app/admin/users'
import { Route as AppItemsItemIdRouteImport } from './routes/_app/items/$itemId'
import { Route as AppProjectsIndexRouteImport } from './routes/_app/projects/index'
import { Route as AppProjectsProjectIdRouteImport } from './routes/_app/projects/$projectId'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const DatenschutzRoute = DatenschutzRouteImport.update({
  id: '/datenschutz',
  path: '/datenschutz',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const ImpressumRoute = ImpressumRouteImport.update({
  id: '/impressum',
  path: '/impressum',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const NutzungsbedingungenRoute = NutzungsbedingungenRouteImport.update({
  id: '/nutzungsbedingungen',
  path: '/nutzungsbedingungen',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountRoute = AppAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminRoute = AppAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AppRoute,
} as any)
const AppClientsRoute = AppClientsRouteImport.update({
  id: '/clients',
  path: '/clients',
  getParentRoute: () => AppRoute,
} as any)
const AppMembersRoute = AppMembersRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => AppRoute,
} as any)
const InviteIdRoute = InviteIdRouteImport.update({
  id: '/invite/$id',
  path: '/invite/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const AppAdminIndexRoute = AppAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminUsageRoute = AppAdminUsageRouteImport.update({
  id: '/usage',
  path: '/usage',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminUsersRoute = AppAdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppItemsItemIdRoute = AppItemsItemIdRouteImport.update({
  id: '/items/$itemId',
  path: '/items/$itemId',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectsIndexRoute = AppProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectsProjectIdRoute = AppProjectsProjectIdRouteImport.update({
  id: '/projects/$projectId',
  path: '/projects/$projectId',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/datenschutz': typeof DatenschutzRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/impressum': typeof ImpressumRoute
  '/login': typeof LoginRoute
  '/nutzungsbedingungen': typeof NutzungsbedingungenRoute
  '/reset-password': typeof ResetPasswordRoute
  '/account': typeof AppAccountRoute
  '/admin': typeof AppAdminRouteWithChildren
  '/clients': typeof AppClientsRoute
  '/members': typeof AppMembersRoute
  '/invite/$id': typeof InviteIdRoute
  '/admin/usage': typeof AppAdminUsageRoute
  '/admin/users': typeof AppAdminUsersRoute
  '/items/$itemId': typeof AppItemsItemIdRoute
  '/projects/$projectId': typeof AppProjectsProjectIdRoute
  '/admin/': typeof AppAdminIndexRoute
  '/projects/': typeof AppProjectsIndexRoute
}
export interface FileRoutesByTo {
  '/datenschutz': typeof DatenschutzRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/impressum': typeof ImpressumRoute
  '/login': typeof LoginRoute
  '/nutzungsbedingungen': typeof NutzungsbedingungenRoute
  '/reset-password': typeof ResetPasswordRoute
  '/account': typeof AppAccountRoute
  '/clients': typeof AppClientsRoute
  '/members': typeof AppMembersRoute
  '/invite/$id': typeof InviteIdRoute
  '/': typeof AppIndexRoute
  '/admin/usage': typeof AppAdminUsageRoute
  '/admin/users': typeof AppAdminUsersRoute
  '/items/$itemId': typeof AppItemsItemIdRoute
  '/projects/$projectId': typeof AppProjectsProjectIdRoute
  '/admin': typeof AppAdminIndexRoute
  '/projects': typeof AppProjectsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/datenschutz': typeof DatenschutzRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/impressum': typeof ImpressumRoute
  '/login': typeof LoginRoute
  '/nutzungsbedingungen': typeof NutzungsbedingungenRoute
  '/reset-password': typeof ResetPasswordRoute
  '/_app/account': typeof AppAccountRoute
  '/_app/admin': typeof AppAdminRouteWithChildren
  '/_app/clients': typeof AppClientsRoute
  '/_app/members': typeof AppMembersRoute
  '/invite/$id': typeof InviteIdRoute
  '/_app/': typeof AppIndexRoute
  '/_app/admin/usage': typeof AppAdminUsageRoute
  '/_app/admin/users': typeof AppAdminUsersRoute
  '/_app/items/$itemId': typeof AppItemsItemIdRoute
  '/_app/projects/$projectId': typeof AppProjectsProjectIdRoute
  '/_app/admin/': typeof AppAdminIndexRoute
  '/_app/projects/': typeof AppProjectsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/datenschutz'
    | '/forgot-password'
    | '/impressum'
    | '/login'
    | '/nutzungsbedingungen'
    | '/reset-password'
    | '/account'
    | '/admin'
    | '/clients'
    | '/members'
    | '/invite/$id'
    | '/admin/usage'
    | '/admin/users'
    | '/items/$itemId'
    | '/projects/$projectId'
    | '/admin/'
    | '/projects/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/datenschutz'
    | '/forgot-password'
    | '/impressum'
    | '/login'
    | '/nutzungsbedingungen'
    | '/reset-password'
    | '/account'
    | '/clients'
    | '/members'
    | '/invite/$id'
    | '/'
    | '/admin/usage'
    | '/admin/users'
    | '/items/$itemId'
    | '/projects/$projectId'
    | '/admin'
    | '/projects'
  id:
    | '__root__'
    | '/_app'
    | '/datenschutz'
    | '/forgot-password'
    | '/impressum'
    | '/login'
    | '/nutzungsbedingungen'
    | '/reset-password'
    | '/_app/account'
    | '/_app/admin'
    | '/_app/clients'
    | '/_app/members'
    | '/invite/$id'
    | '/_app/'
    | '/_app/admin/usage'
    | '/_app/admin/users'
    | '/_app/items/$itemId'
    | '/_app/projects/$projectId'
    | '/_app/admin/'
    | '/_app/projects/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  DatenschutzRoute: typeof DatenschutzRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  ImpressumRoute: typeof ImpressumRoute
  LoginRoute: typeof LoginRoute
  NutzungsbedingungenRoute: typeof NutzungsbedingungenRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  InviteIdRoute: typeof InviteIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/datenschutz': {
      id: '/datenschutz'
      path: '/datenschutz'
      fullPath: '/datenschutz'
      preLoaderRoute: typeof DatenschutzRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/impressum': {
      id: '/impressum'
      path: '/impressum'
      fullPath: '/impressum'
      preLoaderRoute: typeof ImpressumRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/nutzungsbedingungen': {
      id: '/nutzungsbedingungen'
      path: '/nutzungsbedingungen'
      fullPath: '/nutzungsbedingungen'
      preLoaderRoute: typeof NutzungsbedingungenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/account': {
      id: '/_app/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AppAccountRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin': {
      id: '/_app/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AppAdminRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/clients': {
      id: '/_app/clients'
      path: '/clients'
      fullPath: '/clients'
      preLoaderRoute: typeof AppClientsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/members': {
      id: '/_app/members'
      path: '/members'
      fullPath: '/members'
      preLoaderRoute: typeof AppMembersRouteImport
      parentRoute: typeof AppRoute
    }
    '/invite/$id': {
      id: '/invite/$id'
      path: '/invite/$id'
      fullPath: '/invite/$id'
      preLoaderRoute: typeof InviteIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/admin/': {
      id: '/_app/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AppAdminIndexRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/usage': {
      id: '/_app/admin/usage'
      path: '/usage'
      fullPath: '/admin/usage'
      preLoaderRoute: typeof AppAdminUsageRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/users': {
      id: '/_app/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AppAdminUsersRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/items/$itemId': {
      id: '/_app/items/$itemId'
      path: '/items/$itemId'
      fullPath: '/items/$itemId'
      preLoaderRoute: typeof AppItemsItemIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/': {
      id: '/_app/projects/'
      path: '/projects'
      fullPath: '/projects/'
      preLoaderRoute: typeof AppProjectsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/$projectId': {
      id: '/_app/projects/$projectId'
      path: '/projects/$projectId'
      fullPath: '/projects/$projectId'
      preLoaderRoute: typeof AppProjectsProjectIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppAdminRouteChildren {
  AppAdminUsageRoute: typeof AppAdminUsageRoute
  AppAdminUsersRoute: typeof AppAdminUsersRoute
  AppAdminIndexRoute: typeof AppAdminIndexRoute
}

const AppAdminRouteChildren: AppAdminRouteChildren = {
  AppAdminUsageRoute: AppAdminUsageRoute,
  AppAdminUsersRoute: AppAdminUsersRoute,
  AppAdminIndexRoute: AppAdminIndexRoute,
}

const AppAdminRouteWithChildren = AppAdminRoute._addFileChildren(
  AppAdminRouteChildren,
)

interface AppRouteChildren {
  AppAccountRoute: typeof AppAccountRoute
  AppAdminRoute: typeof AppAdminRouteWithChildren
  AppClientsRoute: typeof AppClientsRoute
  AppMembersRoute: typeof AppMembersRoute
  AppIndexRoute: typeof AppIndexRoute
  AppItemsItemIdRoute: typeof AppItemsItemIdRoute
  AppProjectsProjectIdRoute: typeof AppProjectsProjectIdRoute
  AppProjectsIndexRoute: typeof AppProjectsIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAccountRoute: AppAccountRoute,
  AppAdminRoute: AppAdminRouteWithChildren,
  AppClientsRoute: AppClientsRoute,
  AppMembersRoute: AppMembersRoute,
  AppIndexRoute: AppIndexRoute,
  AppItemsItemIdRoute: AppItemsItemIdRoute,
  AppProjectsProjectIdRoute: AppProjectsProjectIdRoute,
  AppProjectsIndexRoute: AppProjectsIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  DatenschutzRoute: DatenschutzRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  ImpressumRoute: ImpressumRoute,
  LoginRoute: LoginRoute,
  NutzungsbedingungenRoute: NutzungsbedingungenRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  InviteIdRoute: InviteIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
